module.exports = __webpack_public_path__ + "img/far-circle-play.86da34ad.svg";